import React, { useState } from "react";
import { test } from "../../../Status";
import './Adding2Archive.css'
import { addToArchive } from "../../../Functions/CRUD/Archive/ArchiveController";

const Adding2Archive = ({ setAddingModal }) => {
  const today = new Date();
  const TodayDate = `${String(today.getDate()).padStart(2, "0")}/${String(
    today.getMonth() + 1
  ).padStart(2, "0")}/${today.getFullYear()}`;

  const [form, setForm] = useState({
    type: "",
    subject: "",
    author: test.name,
    date: TodayDate,
    paper: "",
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newArchive = await addToArchive(form);
      /* setArchiveList((prev) => [newArchive, ...prev]); // refresh list instantly */
      setAddingModal(false);
        window.location.reload(); // reload the page
    } catch (err) {
      alert("Error while adding to archive");
      console.log(err)
    }
  };

  return (
    <div className="Adding2Archive-conatiner Modal-Container">
      <div className="Adding2Archive Modal">
        <div className="Headding">
          <h1>Adding to Archive</h1>
          <span className="close-btn" onClick={() => setAddingModal(false)}>
            &times;
          </span>
        </div>
        <form onSubmit={handleSubmit} className="Information-Section">
          <div className="labels">
            <label>Type : </label>
            <select name="type" onChange={handleChange} required>
              <option value="" disabled selected>
                Select a type
              </option>
              <option value="Marathon">Marathon</option>
              <option value="Training Test">Training Test</option>
              <option value="Mock Contest">Mock Contest</option>
              <option value="Challenge">Challenge</option>
              <option value="Weekly Problem Set">Weekly Problem Set</option>
            </select>
          </div>

          <div className="labels">
            <label>Subject :</label>
            <input
              type="text"
              name="subject"
              placeholder="Write the subject..."
              onChange={handleChange}
              required
            />
          </div>

          <div className="labels">
            <label>Added By :</label>
            <span>{form.author}</span>
          </div>

          <div className="labels">
            <label>Date :</label>
            <span>{form.date}</span>
          </div>

          <div className="labels">
            <label>Link :</label>
            <input
              type="text"
              name="paper"
              placeholder="https://example.com/file.pdf"
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="Submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Adding2Archive;
